// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"729":"e4d671ac","741":"cb788078","787":"9ffa90bf"}[chunkId] + ".chunk.js";
};